
import moment from 'moment';
import { get } from '../../../server/actions';

export const cepReimbursementClime = (resp) => {

    let _url = `/cep/reports/district/${resp.districtId}/claims/${resp.schoolYear}?mealSchoolId=${resp.schoolId}&startDate=${moment(resp.start, 'YYYY-MM-DDTHH:mm:ss').utc().format("YYYY-MM-DDTHH:mm:ss")}&endDate=${moment(resp.end, 'YYYY-MM-DDTHH:mm:ss').utc().format("YYYY-MM-DDTHH:mm:ss")}&yearMonth=${resp.yearMonth}&access_token=`;
    return get(_url);
}
export const cepDailyEditCheckReport = (resp) => {
    let _url = `/cep/reports/${resp.schoolId}/dailyEditCheck/${resp.schoolYear}/${resp.mealType}/${resp.yearMonth}?startDate=${moment(resp.start, 'YYYY-MM-DDTHH:mm:ss').utc().format("YYYY-MM-DDTHH:mm:ss")}&endDate=${moment(resp.end, 'YYYY-MM-DDTHH:mm:ss').utc().format("YYYY-MM-DDTHH:mm:ss")}&access_token=`;
    return get(_url);
}

export const cepReimbursementClimeDistrict = (resp) => {
    let _url = `/cep/reports/district/${resp.districtId}/claims/${resp.schoolYear}?startDate=${moment(resp.start, 'YYYY-MM-DDTHH:mm:ss').utc().format("YYYY-MM-DDTHH:mm:ss")}&endDate=${moment(resp.end, 'YYYY-MM-DDTHH:mm:ss').utc().format("YYYY-MM-DDTHH:mm:ss")}&yearMonth=${resp.yearMonth}&access_token=`;
    return get(_url);
}
export const cepDailyEditCheckReportDistrict = (resp) => {
    let _url = `/cep/reports/district/${resp.districtId}/dailyEditCheck/${resp.schoolYear}/${resp.mealType}/${resp.yearMonth}?startDate=${moment(resp.start, 'YYYY-MM-DDTHH:mm:ss').utc().format("YYYY-MM-DDTHH:mm:ss")}&endDate=${moment(resp.end, 'YYYY-MM-DDTHH:mm:ss').utc().format("YYYY-MM-DDTHH:mm:ss")}&access_token=`;
    return get(_url);
}


// WEBPACK FOOTER //
// ./src/components/District/Reports/cepServices.js